import { z } from 'zod';
import { StaffRole } from './auth';
export const CreateStaffInput = z.object({
    email: z.string().email().trim().toLowerCase(),
    fullName: z.string().min(1).max(120).trim(),
    role: StaffRole,
    password: z.string().min(8),
});
//# sourceMappingURL=staff.js.map